import { render, staticRenderFns } from "./symbolIcon.vue?vue&type=template&id=11b5a002&scoped=true"
import script from "./symbolIcon.vue?vue&type=script&lang=js"
export * from "./symbolIcon.vue?vue&type=script&lang=js"
import style0 from "./symbolIcon.vue?vue&type=style&index=0&id=11b5a002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b5a002",
  null
  
)

export default component.exports